import { BaseApiClient } from './base'
import type { Transaction } from '../../types'

export class TransactionsApi extends BaseApiClient {
  async getUserTransactions(
    limit: number = 50,
    offset: number = 0,
    type?: string
  ): Promise<{ success: boolean; transactions: Transaction[]; count: number }> {
    // Backend expects page and page_size, not limit/offset
    const page = Math.floor(offset / limit) + 1
    const page_size = limit
    
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: page_size.toString(),
    })
    if (type) {
      params.append('type', type)
    }
    
    return this.request(`/transactions?${params.toString()}`)
  }

  async getTransaction(transactionId: string): Promise<{ success: boolean; transaction: Transaction }> {
    return this.request(`/transactions/${transactionId}`)
  }

  async getTranslationTransaction(translationId: string): Promise<{ success: boolean; transaction: Transaction }> {
    return this.request(`/transactions/translation/${translationId}`)
  }
}

